<template>
  <div id="vm-cola-homev2" class="vm-cola-homev2">
    <HomeBanners type="primary" />
    <div class="vm-cola-homev2__label">
      <p>Hi Bestie! Yuk, pilih salah satu untuk dapatkan beauties incaranmu!</p>
    </div>

    <div class="vm-cola-homev2__actions">
      <div class="buy-product" @click="goToCatalog">
        <p class="buy-product__title">Shop Product</p>
        <img src="/static/img/icons/icon-buy-products-2.png" alt="ic-buy-product" />
        <p class="action">Eksplor beauties favorit <br />& belanja super easy!</p>
      </div>
      <div
        v-if="beautyATMData && beautyATMData.is_active && beautyATMData.is_active_in_vm_cola"
        class="play-games"
        @click="goToGames"
      >
        <p class="play-games__title">Play Games</p>
        <img src="/static/img/icons/icon-play-games-1.svg" alt="ic-play-games" />
        <p class="action">
          Menangkan SOCO Points,<br />
          Vouchers, hingga FREE <br />
          beauties!
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import ls from '@/components/helpers/local-storage';
import helpers from '@/mixins/helpers';
//import autotimeout from '@/mixins/auto-timeout';

export default {
  name: 'vmColaHomeV2',
  components: {
    HomeBanners: () => import('@/components/vm-cola/snippets/home-banners/home-banners'),
  },
  mixins: [helpers],

  data() {
    return {
      timeoutDuration: 120000,
      inactivityTimer: null,
    };
  },

  computed: {
    beautyATMData() {
      return this.$store.state.beautyAtmData || null;
    },
    userState() {
      return this.$store.state.QRcode.user;
    },
    isOrderCreated() {
      return this.$store.state.QRcode.is_order_created;
    },
  },

  created() {
    // this.resetCart();
    Promise.all([this.resetCart(), this.fetchBeautyData()]);
  },

  mounted() {
    if (this.userState) {
      this.timeoutDuration = 120000;
    }
    this.resetInactivityTimer();
    this.addInactivityListeners();
  },

  beforeDestroy() {
    this.clearInactivityTimer();
    this.removeInactivityListeners();
  },

  methods: {
    resetCart() {
      ls.remove('cart');
      this.$store.dispatch('resetCart', 0);
    },
    goToCatalog() {
      this.$router.push('/vmcola/products');
    },
    goToGames() {
      this.$router.push({ path: '/vending-machine/login', query: { vmcola: 'true' } });
    },
    fetchBeautyData() {
      this.$store.dispatch('getBeautyAtmData', { isFromVmCola: true });
    },

    // Timer management methods
    resetInactivityTimer() {
      this.clearInactivityTimer();

      const vm = this;
      this.inactivityTimer = setTimeout(() => {
        this.handleTimeoutAction(vm);
      }, this.timeoutDuration);
    },

    clearInactivityTimer() {
      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer);
        this.inactivityTimer = null;
      }
    },

    addInactivityListeners() {
      ['mousemove', 'keydown', 'touchstart', 'scroll'].forEach((event) =>
        window.addEventListener(event, this.resetInactivityTimer)
      );
    },

    removeInactivityListeners() {
      ['mousemove', 'keydown', 'touchstart', 'scroll'].forEach((event) =>
        window.removeEventListener(event, this.resetInactivityTimer)
      );
    },

    handleTimeoutAction(context) {
      this.resetInactivityTimer();

      if (Cookies.get('vending_machine_device') == 'true' && context.$route.name === 'vendingMachineHome') {
        return;
      }

      if (context.$route.path.includes('/soco-vending-machine-event/')) {
        context.$router.push('/soco-vending-machine-event/home');
        return;
      }

      try {
        if ('modal_payment' in context && context.modal_payment) {
          context.modal_payment = false;
          context.backAndCancelPayment(false);
        } else {
          context.cancelOrder(true, '/vmcola/', false, this.isOrderCreated);
        }
      } catch (err) {
        console.log(err);
      }
      context.$router.push('/vmcola/idle');
    },
  },
};
</script>
